/**
 * The bridge between the editor's "Más acciones" (`MockupMoreActionsContainer`, which owns the
 * transfer dialog) and the share popover's "Transferir" (mockup v3 P4). The page creates one bridge,
 * hands `connect` to the container and `openTransfer` to the share popover; until a container
 * connected its dialog, `openTransfer` does nothing. The bridge object is stable across renders.
 */

import { useMemo, useRef } from "react";

export interface MoreActionsBridge {
  /** Opens the transfer of ownership, once the container connected its dialog. */
  readonly openTransfer: () => void;
  /** Called by the container with the function that opens its transfer dialog. */
  readonly connect: (openTransfer: () => void) => void;
}

const NOTHING = (): void => undefined;

export function useMoreActionsBridge(): MoreActionsBridge {
  const opener = useRef<() => void>(NOTHING);
  return useMemo<MoreActionsBridge>(
    () => ({
      openTransfer: () => {
        opener.current();
      },
      connect: (openTransfer) => {
        opener.current = openTransfer;
      },
    }),
    [],
  );
}
